export default __webpack_public_path__ + "static/media/sidemenu_dashboard.4c27306e.svg";